var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-footer',[_c('p',[_vm._v("Copyright 2020 | HANHAISEAFOOD | All Rights Reserved")])])
}
var staticRenderFns = []

export { render, staticRenderFns }